import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/vue-query';
import { MaybeRefOrGetter } from '@vueuse/core';
import { minutesToMilliseconds } from 'date-fns';

import { BRAND } from '../constants';
import { fetchBrand } from '../services';

export const brandQueryKeys = createQueryKeys('brand', {
  show: (signatureRequestKey: MaybeRefOrGetter<string>) => [{ signatureRequestKey }],
});

export function useFetchBrand(signatureRequestKey: MaybeRefOrGetter<string>) {
  const result = useQuery({
    queryKey: brandQueryKeys.show(signatureRequestKey).queryKey,
    queryFn: () => fetchBrand(toValue(signatureRequestKey)),
    staleTime: minutesToMilliseconds(10),
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,

    initialDataUpdatedAt: 0,
    initialData: {
      colors: BRAND.DEFAULT_COLORS,
      logo: '',
    },
  });

  return {
    ...result,
    brand: result.data,
  };
}
